// extracted by mini-css-extract-plugin
export default {"btnsGroup":"navigatesAndAgreement_btnsGroup__jphAz"};